<template>
  <BaseLoading>
    <div class="space-y-3">
      <div class="lazy-loading rounded-md" style="width: 100%; height: 34px" />
      <div class="lazy-loading rounded-md" style="width: 40%; height: 34px" />
      <div class="lazy-loading rounded-md" style="width: 65px; height: 28px" />
    </div>
  </BaseLoading>
</template>
